module.exports = ".mat-table {\n  max-height: 300px;\n  overflow: auto;\n}"